module.exports = __webpack_public_path__ + "static/canine-ortho-logo-62c6b5a3713d7dbaa9037c682d5436f4.jpg";